<template>
  <div class="wrapper">
    <UiConfirm
      ref="confirmBookmark"
      :width="480"
      :action="indexCurrent"
      :action-name="$t('reports.other.save')"
      :action-disabled="pickerDateRangeBookmark === null && checkPeriodBookmark"
      action-fa-icon="check"
      type="success"
      class="confirm-boookmark-edit"
      @save="saveTabBookmark"
    >
      <template v-slot:title>
        <div v-html="$t('reports.other.add_bookmark')" />
      </template>

      <div class="body__wrap">
        <UiInput
          v-model="constTabBookmarkName"
          :label="$t('reports.other.placeholder_name')"
          :placeholder="$t('reports.other.placeholder_name')"
          class="boookmark-edit__input"
          size="big"
        />
        <div class="boookmark-edit__datepicker-wrap">
          <UiCheckbox
            v-model="checkPeriodBookmark"
            :label="$t('reports.other.save_period')"
            :value="true"
            class="t:mb-8"
          />
          <UiDatePicker
            v-model="pickerDateRangeBookmark"
            :disabled="!checkPeriodBookmark || isDisabled"
            :preset-dates-factory="getPickerReportOptions"
            :default-value="1"
            teleport
            size="big"
            :shortcut-name="pickerDatePeriodBookmark"
            @update:model-value="selectDateRangeBookmark"
          />
        </div>
      </div>
    </UiConfirm>
    <UiConfirm
      ref="copyUrlSafari"
      :width="480"
      :action-name="$t('reports.other.close')"
      action-fa-icon="check"
      type="success"
      class="copy-url-safari"
      @save="() => {$refs.copyUrlSafari.close()}"
    >
      <template v-slot:title>
        <div>
          {{ $t('reports.other.share_report') }}
        </div>
      </template>

      <div class="body__wrap">
        <div class="body__title">
          URL
        </div>
        <div class="body__url">
          {{ copyUrl }}
        </div>
        <UiButton
          icon="copy"
          @click="safariCopy"
        >
          {{ $t('reports.other.copy') }}
        </UiButton>
      </div>
    </UiConfirm>
    <div class="inner">
      <Draggable
        v-model="pReportsClone"
        v-bind="dragOptions"
        draggable=".tab__report"
        class="inner-wrap"
        @change="draggable"
        @start="drag = true"
        @end="handleEnd"
      >
        <div
          v-for="(report, index) in reportsClone"
          ref="tab"
          :key="index"
          :class="{
            'active' : currentReportClone === index,
            'home': index === 0,
            'tab__report': index !== 0 && !(tabCountVisible !== null && tabCountVisible < index),
            'hidden-tab': tabCountVisible !== null && tabCountVisible < index
          }"
          class="tab"
          @mousedown.middle="index ? removeReport(index, $event) : () => {}"
          @mousedown="isVisibleTabTooltip = false"
          @mouseup="isVisibleTabTooltip = true"
          @click="selectReport(index)"
        >
          <div
            class="report_name"
          >
            <UiIcon
              v-if="index !== 0 && report.defaultFilter[Object.keys(report.defaultFilter)[0]].op === '='"
              class="context-icon"
              style="margin-right: 4px; display: inline-block; padding-bottom: 2px;"
              name="random"
            />
            <UiIcon
              v-if="index !== 0 && report.defaultFilter[Object.keys(report.defaultFilter)[0]].op === '!='"
              class="context-icon"
              style="margin-right: 4px; display: inline-block; padding-bottom: 2px;"
              name="page-break"
            />
            <span
              class="field"
            >
              {{ index === 0
                ? $t('reports.other.home')
                : `${tabsTranslate(report.defaultFilter[Object.keys(report.defaultFilter)[0]].group, 'defaulTitle')} :`
              }}
            </span>
            <span
              v-if="index !== 0"
            >
              <ElDropdown
                trigger="click"
                placement="bottom"
                :disabled="!(report.defaultFilter[Object.keys(report.defaultFilter)[0]].row_name.length - 1)"
              >
                <span>
                  <ElTooltip
                    :content="
                      `${tabsTranslate(report, 'title')}
                      ${tabsTranslate(report)}`
                    "
                    :disabled="!(arrayWidthItemForTooltip[index - 1] === 150 && isVisibleTabTooltip)"
                    placement="top"
                  >
                    <span class="wrap-value-tabs-ell">
                      <span
                        ref="valueText"
                        class="value"
                      >
                        {{ $filters.datetimeFilter(tabsTranslate(report, 'title'), Object.keys(report.defaultFilter)[0]) }}
                      </span>
                      <span class="count-value">{{ tabsTranslate(report) }}</span>

                    </span>
                  </ElTooltip>
                </span>

                <template v-slot:dropdown>
                  <ElDropdownMenu
                    class="ddgroup drill-item"
                  >
                    <ElDropdownItem
                      v-for="(row, ind) in report.defaultFilter[Object.keys(report.defaultFilter)[0]].row_name"
                      :key="ind"
                    >
                      <span class="drill-item--text">
                        {{
                          $filters.datetimeFilter(
                            row[report.defaultFilter[Object.keys(report.defaultFilter)[0]].group],
                            Object.keys(report.defaultFilter)[0]
                          )
                        }}
                      </span>
                      <UiIcon
                        color="var(--text-negative)"
                        name="times"
                        class="close"
                        @click.stop="removeItemCurrentFilter(row, report.defaultFilter[Object.keys(report.defaultFilter)[0]].row_id[ind], Object.keys(report.defaultFilter)[0], 'report')"
                      />
                    </ElDropdownItem>
                  </ElDropdownMenu>
                </template>
              </ElDropdown>
            </span>
          </div>
          <div
            v-if="index !== 0"
            class="ctrls"
          >
            <ElDropdown
              trigger="hover"
              :show-timeout="0"
              :hide-timeout="200"
              placement="bottom-start"
              @visible-change="handleAngleOpen"
            >
              <UiIcon
                :class="angleOpen[index] ? 'angle-down-rotate' : 'angle-down-no-rotate'"
                name="angle-down"
                @mouseover="addClassRotate(index, $event)"
              />
              <template v-slot:dropdown>
                <ElDropdownMenu class="ddgroup ddgroup__tab">
                  <ElDropdownItem
                    :disabled="isDisabledGenUrl[index]"
                    @click="generateURL(index, $event);"
                  >
                    <span class="title">{{ $t('reports.other.copy_url2') }}</span>
                    <UiIcon
                      :class="{'disabled': isDisabledGenUrl[index]}"
                      class="tab-action"
                      color="var(--text-link)"
                      name="link"
                    />
                  </ElDropdownItem>
                  <ElDropdownItem
                    class="afterline-item-tab"
                  >
                    <div
                      class="ddgroup__wrapper"
                      @click="indexCurrent = index; setBookmarkName(index); clickBookmarkStar(report, index, 'open');"
                    >
                      <span class="title">{{ $t('reports.other.save_bookmark') }}</span>
                      <i
                        class="fas fa-star"
                        :class="report.isPinnedBookmark ? 'boookmark-edit__star-active' : 'boookmark-edit__star-disactive'"
                      />
                    </div>
                  </ElDropdownItem>
                  <ElDropdownItem
                    class="underline-item-tab"
                    @click="resetDefaultTab(index)"
                  >
                    <span class="title">{{ $t('reports.payments.reset_filter') }}</span>
                    <UiIcon
                      class="tab-action"
                      color="var(--text-link)"
                      name="undo"
                    />
                  </ElDropdownItem>
                </ElDropdownMenu>
              </template>
            </ElDropdown>
            <ElTooltip
              :content="$t('reports.other.remove_report')"
              placement="top"
            >
              <UiIcon
                class="tab-action"
                color="var(--text-negative)"
                name="times"
                @click="removeReport(index, $event)"
              />
            </ElTooltip>
          </div>
          <div
            v-else
            class="ctrls"
          >
            <ElDropdown
              trigger="hover"
              :show-timeout="0"
              :hide-timeout="200"
              placement="bottom-start"
              @visible-change="handleAngleOpen"
            >
              <UiIcon
                :class="angleOpen[index] ? 'angle-down-rotate' : 'angle-down-no-rotate'"
                name="angle-down"
                @mouseover="addClassRotate(index, $event)"
              />
              <template v-slot:dropdown>
                <ElDropdownMenu
                  class="ddgroup ddgroup__tab"
                >
                  <ElDropdownItem
                    :disabled="isDisabledGenUrl[index]"
                    @click="generateHomeURL($event);"
                  >
                    <span class="title">{{ $t('reports.other.copy_url2') }}</span>
                    <UiIcon
                      :class="{'disabled': isDisabledGenUrl[index]}"
                      class="tab-action"
                      color="var(--text-link)"
                      name="link"
                    />
                  </ElDropdownItem>
                  <ElDropdownItem
                    class="underline-item-tab"
                    @click="resetHomeReport($event)"
                  >
                    <span class="title">{{ $t('reports.payments.reset_filter') }}</span>
                    <UiIcon
                      class="tab-action"
                      color="var(--text-link)"
                      name="undo"
                    />
                  </ElDropdownItem>
                </ElDropdownMenu>
              </template>
            </ElDropdown>
          </div>
        </div>
        <div
          v-if="isVisibleTabMore"
          :class="{'active': isNavTabDropdownVisible}"
          class="nav-tab-dropdown"
        >
          <ElPopover
            v-model:visible="isNavTabDropdownVisible"
            popper-class="nav-tab-dropdown__popover"
            placement="bottom-start"
            :visible-arrow="false"
            width="auto"
            trigger="hover"
          >
            <template v-slot:reference>
              <div class="nav-tab-dropdown__wrap">
                <UiIcon
                  color="#303634"
                  name="bars"
                />
                <span class="nav-tab-dropdown__text">
                  {{ $t('reports.other.more', { number: reportsClone.length - tabCountVisible - 1 }) }}
                </span>
                <UiIcon
                  :class="isNavTabDropdownVisible ? 'angle-down-rotate' : 'angle-down-no-rotate'"
                  name="angle-down"
                />
              </div>
            </template>
            <UiScrollbar
              wrap-class="nav-tab-dropdown__scroll-wrap"
              view-class="view-box"
              :native="false"
            >
              <div class="nav-tab-dropdown__item-wrap">
                <div
                  v-for="(report, index) in reportsCloneDropdown"
                  :key="index"
                  class="nav-tab-dropdown__item"
                  @click="selectReport(tabCountVisible + index + 1); isNavTabDropdownVisible = false"
                >
                  <div class="nav-tab-dropdown__title-wrap">
                    <UiIcon
                      v-if="report.defaultFilter[Object.keys(report.defaultFilter)[0]].op === '='"
                      class="context-icon"
                      style="margin-right: 4px; display: inline-block; padding-bottom: 2px;"
                      name="random"
                    />
                    <UiIcon
                      v-if="report.defaultFilter[Object.keys(report.defaultFilter)[0]].op === '!='"
                      class="context-icon"
                      style="margin-right: 4px; display: inline-block; padding-bottom: 2px;"
                      name="page-break"
                    />
                    <span
                      class="field"
                    >{{ `${tabsTranslate(report.defaultFilter[Object.keys(report.defaultFilter)[0]].group, 'defaulTitle')} :` }}</span>
                    <span class="value">
                      {{ $filters.datetimeFilter(tabsTranslate(report, 'title'), Object.keys(report.defaultFilter)[0]) }}
                      {{ tabsTranslate(report) }}
                    </span>
                  </div>
                  <div class="nav-tab-dropdown__ctrls">
                    <UiIcon
                      class="tab-action"
                      color="var(--text-negative)"
                      name="times"
                      @click.stop="removeReport(tabCountVisible + index + 1, $event)"
                    />
                  </div>
                </div>
              </div>
            </UiScrollbar>
          </ElPopover>
        </div>
      </Draggable>
    </div>
    <div
      v-if="tab.isVisible"
      class="nav-tabs"
    >
      <span
        :class="{'disabled': tab.disabledLeft}"
        class="nav-tabs__left"
        @click="tabsMove('left')"
      >
        <i class="fas fa-angle-left" />
      </span>
      <span
        :class="{'disabled': tab.disabledRight}"
        class="nav-tabs__right"
        @click="tabsMove('right')"
      >
        <i class="fas fa-angle-right" />
      </span>
    </div>
    <slot />
  </div>
</template>

<script>
// import draggable from 'vuedraggable';
import { VueDraggable as draggable } from 'vue-draggable-plus';
import { mapGetters, mapState } from 'vuex';
import datePickerShortcuts from '@/views/mixins/date-picker-shortcuts';
import { version } from '../../package.json';
import isSafari from '../helpers/is-safari';

export default {
  name: 'TabsReport',
  components: {
    Draggable: draggable,
  },
  mixins: [datePickerShortcuts],
  props: {
    reports: {
      type: Array,
      required: true,
    },
    currentReport: {
      type: Number,
      required: true,
    },
    bookmarks: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'removeItemCurrentFilter',
    'selectReport',
    'update:reports',
    'saveBookmark',
    'update:bookmarks',
    'updateReport',
    'resetHomeReport',
    'getReport',
    'resetRows',
    'selectDateRange',
    'isVisible',
  ],
  data() {
    return {
      isVisibleTabTooltip: true,
      isNavTabDropdownVisible: false,
      tabCountVisible: null,
      arrayWidthItemForTooltip: [],

      reportsClone: [],
      currentReportClone: 0,

      indexCurrent: 0,
      drag: false,
      angleOpenIndex: -1,
      angleOpen: [],
      constTabBookmarkName: '',
      isPinnedPopover: [],
      checkPeriodBookmark: false,
      isDisabled: false,
      pickerDateRangeBookmark: [],
      pickerDatePeriodBookmark: '',
      bookmarksSync: this.bookmarks,
      isDisabledGenHomeUrl: false,
      isDisabledGenUrl: [],

      tab: {
        isVisible: false,
        selectTab: false,
        disabledLeft: false,
        disabledRight: false,
      },

      copyUrl: '',
      pReportsClone: [],
    };
  },
  computed: {
    ...mapGetters('reports', ['reportsSettings']),
    ...mapState('other', ['isDragged']),

    dragOptions() {
      return {
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    reportsCloneDropdown() {
      return this.reportsClone.slice(-(this.reportsClone.length - this.tabCountVisible - 1));
    },
    isVisibleTabMore() {
      if (!(this.tabCountVisible !== null && this.tabCountVisible < this.reportsClone.length - 1)) {
        // eslint-disable-next-line
        this.isNavTabDropdownVisible = false;
      }
      return this.tabCountVisible !== null && this.tabCountVisible < this.reportsClone.length - 1;
    },
  },
  watch: {
    tab: {
      deep: true,
      handler({ isVisible }) {
        this.$emit('isVisible', isVisible);
      },
    },
    reports: {
      deep: true,
      handler(report) {
        /* блокируем кнопку линк */
        this.reportsClone = [...report];
        this.isDisabledGenHomeUrl = false;
        this.isDisabledGenUrl = this.$_.clone(this.isDisabledGenUrl.fill(false));
      },
    },
    currentReport: {
      deep: true,
      handler(index) {
        /* блокируем кнопку линк */
        this.currentReportClone = index;
        this.isDisabledGenHomeUrl = false;
        this.isDisabledGenUrl = this.$_.clone(this.isDisabledGenUrl.fill(false));
      },
    },
    reportsClone: {
      deep: true,
      immediate: true,
      handler(value) {
        this.pReportsClone = value.slice(1);
        this.getWidthItemForTooltip();
      },
    },
  },
  created() {
    this.tabCountVisible = this.$ls.get('reports/more_tab') || null;
    this.currentReportClone = this.currentReport;
  },
  mounted() {
    this.getWidthItemForTooltip();
  },
  methods: {
    async safariCopy() {
      try {
        await this.$clipboard(this.copyUrl);
        this.$eventBus.$emit('notify-event', {
          type: 'info',
          text: this.$t('reports.other.copied_to_clipboard'),
        });
      } catch (error) {
        this.$eventBus.$emit('notify-event', {
          type: 'error',
          text: this.$t('reports.other.failed_to_copy'),
        });
      }
      this.$refs.copyUrlSafari.close();
    },

    getWidthItemForTooltip() {
      this.$nextTick(() => {
        this.arrayWidthItemForTooltip = [];
        if (this.$refs.valueText) {
          this.$refs.valueText.forEach((elem, i) => {
            this.$set(this.arrayWidthItemForTooltip, i, elem.offsetWidth || 0);
          });
        }
      });
    },
    lastTab() {
      let tabCountVisible = null;
      let tabWidthIterator = 0;
      if (this.$el) {
        const tabWrapWidth = this.$el ? this.$el.querySelector('.inner').offsetWidth : 0;

        this.$refs.tab.forEach((e, i) => {
          if (tabCountVisible === null) tabWidthIterator += e.offsetWidth + 8;

          if (tabWrapWidth - 400 < tabWidthIterator && tabCountVisible === null) {
            tabCountVisible = i;
          }
        });
        const tabsCollection = this.$el.querySelectorAll('.inner .tab');
        tabsCollection.forEach((el, i) => {
          if (tabCountVisible < i && tabCountVisible !== null) {
            el.classList.add('hidden-tab');
          } else {
            el.classList.remove('hidden-tab');
          }
        });
      }
      this.tabCountVisible = tabCountVisible;
      this.$ls.set('reports/more_tab', tabCountVisible);
      let changeItem;
      if (this.currentReportClone > tabCountVisible
          && tabCountVisible !== null
          && changeItem === undefined) {
        this.$store.commit('other/isDragged', true);
        changeItem = this.reportsClone.splice(this.currentReportClone, 1);
        this.reportsClone.splice(tabCountVisible, 0, ...changeItem);
        this.currentReportClone = tabCountVisible;

        this.$store.commit('other/setCurrentReportClone', tabCountVisible);
        this.$store.commit('other/setReportsClone', this.$_.cloneDeep(this.reportsClone));
      } else {
        changeItem = undefined;
      }
    },
    resetDefaultTab(index) {
      const pickerOptions = this.getPickerReportOptions();
      const objectDefaultSettings = {
        affiliateCreatedAt: {
          currentAffiliateDateOperator: '=',
          affiliateCreatedAtStart: undefined,
          affiliateCreatedAtEnd: undefined,
        },
        trafficType: 'all',
        playersType: 'all',
        sort_by: this.reportsClone[index].group_by,
        sort_dir: 'desc',
        search: {},
        searchQuery: {},
        columnsFilter: {},
        dateRange: pickerOptions[1].value.range,
        datePeriod: pickerOptions[1].value.short_title,
        page: 1,
      };
      // eslint-disable-next-line
      for (const key in objectDefaultSettings) {
        if (objectDefaultSettings.hasOwnProperty(key)) {
          const element = objectDefaultSettings[key];
          this.$set(this.reportsClone[index], key, element);
        }
      }

      this.$emit('selectDateRange', objectDefaultSettings.dateRange, objectDefaultSettings.datePeriod);
      this.$emit('update:reports', this.reportsClone);
      this.$emit('resetRows');
      this.$emit('getReport');
    },
    addClassRotate(index) {
      this.angleOpenIndex = index;
    },
    handleAngleOpen(isOpen) {
      if (this.angleOpenIndex !== -1 && isOpen) {
        this.$set(this.angleOpen, this.angleOpenIndex, isOpen);
      } else {
        this.$set(this.angleOpen, this.angleOpenIndex, false);
        this.angleOpenIndex = -1;
      }
    },
    draggable() {
      this.$store.commit('other/isDragged', true);
    },
    handleEnd(event) {
      this.drag = false;
      this.isVisibleTabTooltip = true;

      const { newIndex, oldIndex } = event;
      let currentReport = this.currentReportClone;

      if (this.currentReportClone === oldIndex) {
        currentReport = newIndex;
      } else {
        if ((this.currentReportClone > oldIndex && this.currentReportClone <= newIndex)) {
          currentReport -= 1;
        } else if ((this.currentReportClone < oldIndex && this.currentReportClone >= newIndex)) {
          currentReport += 1;
        }
      }

      this.currentReportClone = currentReport;
      this.reportsClone = [this.reportsClone[0]].concat(this.pReportsClone);
      this.$store.commit('other/setCurrentReportClone', currentReport);
      this.$store.commit('other/setReportsClone', this.$_.cloneDeep(this.reportsClone));
    },

    tabsTranslate(report, flag) {
      if (flag === 'title') {
        return report.defaultFilter[Object.keys(report.defaultFilter)[0]]
          ? `${report.defaultFilter[Object.keys(report.defaultFilter)[0]]
            .row_name[0][report.defaultFilter[Object.keys(report.defaultFilter)[0]].group]}`
          : '';
      }
      if (flag === 'defaulTitle') {
        const defaulTitle = this.reportsSettings.dimensions
          .find((dim) => dim.column_name === report);

        return defaulTitle ? defaulTitle.title : '';
      }
      return report.defaultFilter[Object.keys(report.defaultFilter)[0]].row_name.length - 1
        ? `[+${report.defaultFilter[Object.keys(report.defaultFilter)[0]].row_name.length - 1}]`
        : '';
    },

    selectDateRangeBookmark(range, period) {
      this.isDisabled = true;
      if (!range) {
        const shortcut = period && this.getPickerReportOptions().find((el) => el.value.short_title === period);
        if (shortcut) {
          this.pickerDateRangeBookmark = shortcut.value.range;
          this.pickerDatePeriodBookmark = shortcut.value.short_title;
        }
      } else {
        this.pickerDateRangeBookmark = this.$_.cloneDeep(range);
        this.pickerDatePeriodBookmark = period;
      }

      this.$nextTick(() => {
        this.isDisabled = false;
      });
    },
    resetHomeReport(event) {
      this.$emit('resetHomeReport', event);
    },
    async generateURL(index, event) {
      this.$emit('updateReport');
      this.isDisabledGenUrl[index] = true;
      this.isDisabledGenUrl = [...this.isDisabledGenUrl];
      setTimeout(() => {
        this.isDisabledGenUrl[index] = false;
        this.isDisabledGenUrl = [...this.isDisabledGenUrl];
      }, 8000);

      event.stopPropagation();

      const q = this.isDragged ? this.reportsClone[index] : this.reports[index];
      q.type = 'add';
      q.version = this.ver;
      try {
        const { data: { payload } } = await this.$api.postQueryShortUrl(q);
        const shortId = payload.short_id;
        const url = `${window.location.origin}/reports/custom?short_url=${shortId}`;
        this.copyUrl = url;
        if (isSafari) {
          this.$refs.copyUrlSafari.open();
        } else {
          await this.$clipboard(url);
          this.$eventBus.$emit('notify-event', {
            type: 'info',
            text: this.$t('reports.other.copied_to_clipboard'),
          });
        }
      } catch (error) {
        this.$eventBus.$emit('notify-event', {
          type: 'error',
          text: this.$t('reports.other.failed_to_copy'),
        });
      }
    },
    async generateHomeURL(event) {
      this.$emit('updateReport');

      event.stopPropagation();
      setTimeout(() => this.isDisabledGenHomeUrl = false, 8000);

      const q = this.reports[0];
      q.type = 'home';
      q.version = version;
      try {
        const { data: { payload } } = await this.$api.postQueryShortUrl(q);
        const shortId = payload.short_id;
        const url = `${window.location.origin}/reports/custom?short_url=${shortId}`;
        this.copyUrl = url;
        if (isSafari) {
          this.$refs.copyUrlSafari.open();
        } else {
          await this.$clipboard(url);
          this.$eventBus.$emit('notify-event', {
            type: 'info',
            text: this.$t('reports.other.copied_to_clipboard'),
          });
        }
      } catch (error) {
        this.$eventBus.$emit('notify-event', {
          type: 'error',
          text: this.$t('reports.other.failed_to_copy'),
        });
      }
    },
    removeReport(index, event) {
      event.stopPropagation();
      this.reportsClone[index].isPinned = false;
      this.currentReportClone = 0;
      this.$emit('updateReport');
      this.$emit('selectReport', 0, 'noTick');
      this.reportsClone.splice(index, 1);
      this.$emit('update:reports', this.reportsClone);
    },
    saveTabBookmark(index) {
      this.reportsClone[index].bookmarkName = this.constTabBookmarkName;
      this.reportsClone[index].version = version;
      this.reportsClone[index].uid = `${+new Date()}0${(Math.random() * 100).toFixed(0)}`;
      this.reportsClone[index].isPinnedBookmark = true;
      if (this.checkPeriodBookmark) {
        const dateRange = this.pickerDateRangeBookmark;
        this.bookmarks.push({ ...this.reportsClone[index], dateRange, datePeriod: this.pickerDatePeriodBookmark });
      } else {
        this.bookmarks.push({ ...this.reportsClone[index], dateRange: [], datePeriod: null });
      }
      this.$refs.confirmBookmark.close();
      this.$emit('update:reports', this.reportsClone);
      this.$emit('update:bookmarks', this.bookmarks);
      this.$emit('saveBookmark');
    },
    setBookmarkName(index) {
      if (this.reportsClone[index].bookmarkName === '') {
        const objDefaultTab = this.reportsClone[index].defaultFilter;
        const keyName = Object.keys(objDefaultTab);
        const subKeyName = Object.keys(objDefaultTab[keyName].row_name[0])[0];

        this.tabsTranslate(Object.keys(this.reportsClone[index].defaultFilter)[0], 'defaulTitle');
        this.constTabBookmarkName = `${`${ this.tabsTranslate(subKeyName, 'defaulTitle') }:`} ${this.reportsClone[index].defaultFilter[Object.keys(this.reportsClone[index].defaultFilter)[0]].visible}`;
      } else {
        this.constTabBookmarkName = this.reportsClone[index].bookmarkName;

        this.$emit('update:reports', this.reportsClone);
      }
      this.$refs.confirmBookmark.open();
    },
    clickBookmarkStar(report, index, type) {
      if (type === 'open') {
        const uid = report.hasOwnProperty('uid') ? report.uid : '';
        if (uid) {
          const thisBookmark = this.bookmarks.find((e) => e.uid === uid);

          if (thisBookmark.dateRange.length) {
            this.pickerDateRangeBookmark = this.$_.cloneDeep(thisBookmark.dateRange);
            this.pickerDatePeriodBookmark = this.$_.cloneDeep(thisBookmark.datePeriod);
            this.checkPeriodBookmark = true;
          } else {
            this.pickerDateRangeBookmark = this.$_.cloneDeep(report.dateRange);
            this.pickerDatePeriodBookmark = this.$_.cloneDeep(report.datePeriod);
            this.checkPeriodBookmark = false;
          }
        } else {
          this.pickerDateRangeBookmark = this.$_.cloneDeep(report.dateRange);
          this.pickerDatePeriodBookmark = this.$_.cloneDeep(report.datePeriod);
          this.checkPeriodBookmark = false;
        }
      } else {
        this.checkPeriodBookmark = false;
      }
    },
    selectReport(index) {
      this.$emit('selectReport', index);
    },
    removeItemCurrentFilter(row, id, key, flag) {
      this.$emit('removeItemCurrentFilter', row, id, key, flag);
    },
  },
};
</script>

<style lang="scss">
  .ghost {
    opacity: 0.5;
  }
  .tabs-report__picker {
    z-index: 10000!important;
  }
  .tab__report {
    .el-dropdown.is-disabled {
      color: var(--el-text-color-regular);
    }
  }
</style>
